<template>
  <es-popup
    :show="show"
    position="center"
    custom-class="custom-class"
    bind:overlay-click="closePopup"
  >
    <view class="description-popup">
      <view class="description-copywritting">
        <view class="description-title">便捷购票说明</view>
        <view class="description-content">
          <text>
            1、我们会全力为您出票，如果出票结果受余票变动及购票人数等因素影响，无法保证100%购票成功 
            2、如果出票失败，票款及服务费会全部原路返还
            3、退票/改签需至车站窗口办理，不支持网上在线退改
            4、出票成功即享便捷购票服务，若退票，服务费不退还
            5、便捷购票，享7*24 小时预定服务
            6、因便捷购票线上无须核验身份，故无法提供除儿童票外的其他优惠票服务（学生、伤残、军人等），可正常出正价票
            7、便捷购票服务费不可使用优惠券抵扣
          </text>
        </view>
      </view>
      <view class="description-confirm" bindtap="closePopup">我知道了</view>
    </view>
  </es-popup>
</template>

<style lang="stylus" scoped>
  .description-popup
    display flex
    flex-direction column
    justify-content space-between
    align-items center
    padding-top 20px
    box-sizing border-box
    height auto
    width 280px
    border-radius 15px
    background #fff
    .description-copywritting
      display flex
      flex-direction column
      border-bottom 0.5px solid rgba(0, 0, 0, 0.08)
      font-family PingFang SC
      .description-title
        height 20px
        font-size 20px
        font-weight 500
        line-height 20px
        text-align center
        margin-bottom 13px
      .description-content
        font-size 14px
        line-height 21px
        margin 0 20px 18.5px 20px
        letter-spacing 0px
        color #666666
    .description-confirm
      height 50px
      display: flex;
      justify-content center
      align-items: center;
      font-family PingFangSC-Regular
      color #666
      font-weight normal
      font-size 16px
      letter-spacing 0px

</style>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      show: {
        type: Boolean,
        value: false,
      },
    },
    methods: {
      closePopup() {
        this.$trigger('close')
      },
    },
  })
</script>

<script name="json">
  module.exports = {
    component: true,
  }
</script>